import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import { findPreorder, updatePreorder } from '../service/OrdersService';
import Message from '../components/LoadingError/Error';
import { useEffect } from 'react';
import Loading from '../components/LoadingError/Loading';

const PaymentScreen = ({ user }) => {
  const [preorder, setPreorder] = useState();
  const [paymentMethod, setPaymentMethod] = useState({
    card: false,
    mano: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const navigate = useNavigate();
  const params = useParams();
  const preorderId = params.id;

  useEffect(() => {
    if (user) {
      findPreorder(preorderId).then((preorder) => {
        setPreorder(preorder[0]);
        setLoading(false);
        const deliveryAddress = preorder[0].deliveryAddress;
        const deliveryMethod = preorder[0].deliveryMethod;
        const preorderPaymentMethod = preorder[0].paymentMethod;
        if (deliveryMethod === 'domicilio' && !deliveryAddress) {
          navigate(`/shipping/${preorderId}`);
        }
        if (preorderPaymentMethod) {
          const paymentMethodCopy = { ...paymentMethod };
          paymentMethodCopy[preorderPaymentMethod] = true;
          setPaymentMethod(paymentMethodCopy);
        }
      });
    }
  }, [user]);

  const handlePaymentMethod = (method) => {
    if (method === 'card') {
      if (paymentMethod.card) {
        setPaymentMethod({
          card: false,
          mano: false,
        });
      } else {
        setPaymentMethod({
          card: true,
          mano: false,
        });
      }
    }
    if (method === 'mano') {
      if (paymentMethod.mano) {
        setPaymentMethod({
          card: false,
          mano: false,
        });
      } else {
        setPaymentMethod({
          card: false,
          mano: true,
        });
      }
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();

    updatePreorder(
      {
        paymentMethod: Object.keys(paymentMethod).filter(
          (method) => paymentMethod[method]
        )[0],
      },
      preorderId
    )
      .then(() => navigate(`/placeorder/${preorderId}`))
      .catch((error) => setError(error.response.data.message));
  };

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex justify-content-center align-items-center mt-md-5'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <form
            className='Login2 col-md-8 col-lg-6 col-11'
            onSubmit={submitHandler}
          >
            <h6>SELECCIONA MÉTODO DE PAGO</h6>
            <div className='payment-container mt-5'>
              <div className='radio-container my-3'>
                <input
                  className='form-check-input'
                  type='radio'
                  value='card'
                  checked={paymentMethod.card}
                  onClick={(e) => handlePaymentMethod(e.target.value)}
                />
                <label className='form-check-label'>Tarjeta de Crédito</label>
              </div>
              {preorder?.deliveryMethod !== 'domicilio' && (
                <div className='radio-container my-3'>
                  <input
                    className='form-check-input'
                    type='radio'
                    value='mano'
                    checked={paymentMethod.mano}
                    onClick={(e) => handlePaymentMethod(e.target.value)}
                  />
                  <label className='form-check-label'>Pago en mano</label>
                </div>
              )}
            </div>
            <button
              disabled={
                !paymentMethod.card &&
                !paymentMethod.mano
              }
              style={{
                backgroundColor:
                  !paymentMethod.card &&
                  !paymentMethod.mano &&
                  'grey',
              }}
              type='submit'
            >
              Continuar
            </button>
          </form>
        )}
      </div>
    </>
  );
};

export default PaymentScreen;
